import { render, staticRenderFns } from "./NuevaUnidad.vue?vue&type=template&id=1be805c4"
import script from "./NuevaUnidad.vue?vue&type=script&lang=js"
export * from "./NuevaUnidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports